import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../../../../../core/domain/Base/BaseDomain.factory';

import {ModelsRegistry} from '../../../../../core/system/modelsRegistry/ModelsRegistry';
import {CromModel} from './Crom.model';

@injectable()
export class CromModelFactory
  implements BaseDomainFactory<CromModel, CromModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: CromModel.Props): CromModel {
    return this.modelsRegistry.put(new CromModel(props));
  }
}
